import { HydrateOption } from '@core/enums';
import { isSSR } from '@helpers/ssr';
import withWidget from '@hoc/withWidget';
import Button from '@stories/Components/Buttons/Button/Button';
import Recaptcha from '@stories/Components/Forms/Recaptcha/Recaptcha';
import React, { useEffect, useRef, useState } from 'react';
import { useForm } from 'react-hook-form';
import { LoginModalStyles as LoginStyles } from '../../LoginModal/LoginModal.styles';
import { LoginSignupStyles as SharedStyles } from '../LoginSignup.styles';
import { SignupFormStyles as S } from './SignupForm.styles';
import UrlResolver from '@core/url-resolver/UrlResolver';
import ApiService from '@core/api/services/ApiService';
import Checkbox from '@stories/Components/Forms/Checkbox/Checkbox';
import withRedux from '@helpers/withRedux';
import { useDispatch } from 'react-redux';
import { LoginRedirectType } from '@redux/ducks/app/app.reducer';
const SignupForm = (props) => {
    const dispatch = useDispatch();
    const containerRef = useRef(null);
    const [isLoading, setIsLoading] = useState(false);
    const { register, handleSubmit, formState: { errors }, setError, setValue, watch, } = useForm();
    const submit = async (state) => {
        setIsLoading(true);
        const params = {
            ...state,
            redirectUri: props.redirectUri,
            cultureCode: props.cultureCode,
        };
        const response = await ApiService.request({
            baseUrl: UrlResolver.getDomain(),
            method: 'POST',
            controller: 'register',
            slug: 'submit',
            params,
        });
        if (!response.status.success) {
            response.validationErrors?.forEach((error) => {
                if (error.errorSourceId) {
                    setError(error.errorSourceId, {
                        message: error.message,
                    });
                }
            });
            setIsLoading(false);
        }
        else {
            if (props.redirectUri) {
                window.location.replace(props.redirectUri);
            }
        }
    };
    useEffect(() => {
        setTimeout(() => {
            if (containerRef?.current && !isSSR() && !props.showSignupForm) {
                containerRef.current.scrollTo({ top: 0, left: 0, behavior: 'smooth' });
            }
        }, 500);
    }, [containerRef, isSSR, props.showSignupForm]);
    return (React.createElement(S.Container, { ref: containerRef },
        React.createElement(SharedStyles.FormContainer, null,
            React.createElement(SharedStyles.FormWrapper, null,
                React.createElement(SharedStyles.FormContent, null,
                    React.createElement(SharedStyles.FormTitle, null, props.translations['custom.signup.heading']),
                    React.createElement(LoginStyles.Field, null,
                        React.createElement(LoginStyles.Label, null,
                            "*",
                            props.translations['custom.signup.first-name']),
                        React.createElement(LoginStyles.Input, { required: true, type: "text", placeholder: `${props.translations['custom.signup.first-name.placeholder']}`, ...register('firstName', {
                                required: props.translations['custom.register.errors.first-name'],
                            }) }),
                        errors.firstName?.message && (React.createElement(LoginStyles.Error, null, errors.firstName.message))),
                    React.createElement(LoginStyles.Field, null,
                        React.createElement(LoginStyles.Label, null,
                            "*",
                            props.translations['custom.signup.last-name']),
                        React.createElement(LoginStyles.Input, { required: true, type: "text", placeholder: `${props.translations['custom.signup.last-name.placeholder']}`, ...register('lastName', {
                                required: props.translations['custom.register.errors.last-name'],
                            }) }),
                        errors.lastName?.message && (React.createElement(LoginStyles.Error, null, errors.lastName.message))),
                    React.createElement(LoginStyles.Field, null,
                        React.createElement(LoginStyles.Label, null,
                            "*",
                            props.translations['custom.signup.email']),
                        React.createElement(LoginStyles.Input, { required: true, type: "email", placeholder: `${props.translations['custom.signup.email.placeholder']}`, ...register('emailAddress', {
                                required: props.translations['custom.register.errors.email'],
                            }) }),
                        errors.emailAddress?.message && (React.createElement(LoginStyles.Error, null, errors.emailAddress.message))),
                    React.createElement(LoginStyles.Field, null,
                        React.createElement(LoginStyles.Label, null,
                            "*",
                            props.translations['custom.signup.company-name']),
                        React.createElement(LoginStyles.Input, { required: true, type: "text", placeholder: `${props.translations['custom.signup.company-name.placeholder']}`, ...register('companyName', {
                                required: props.translations['custom.register.errors.company-name'],
                            }) }),
                        errors.companyName?.message && (React.createElement(LoginStyles.Error, null, errors.companyName.message))),
                    React.createElement(LoginStyles.Field, null,
                        React.createElement(LoginStyles.Label, null,
                            "*",
                            props.translations['custom.signup.postcode']),
                        React.createElement(LoginStyles.Input, { required: true, type: "text", placeholder: `${props.translations['custom.signup.postcode.placeholder']}`, ...register('postcode', {
                                required: props.translations['custom.register.errors.postcode'],
                            }) }),
                        errors.postcode?.message && (React.createElement(LoginStyles.Error, null, errors.postcode.message))),
                    React.createElement(LoginStyles.Field, null,
                        React.createElement(LoginStyles.Label, null,
                            "*",
                            props.translations['custom.signup.password']),
                        React.createElement(LoginStyles.Input, { required: true, type: "password", placeholder: `${props.translations['custom.signup.password.placeholder']}`, ...register('password', {
                                required: props.translations['custom.register.errors.password'],
                            }) }),
                        errors.password?.message && (React.createElement(LoginStyles.Error, null, errors.password.message))),
                    React.createElement(LoginStyles.Field, null,
                        React.createElement(LoginStyles.Label, null,
                            "*",
                            props.translations['custom.signup.confirm-password']),
                        React.createElement(LoginStyles.Input, { required: true, type: "password", placeholder: `${props.translations['custom.signup.confirm-password.placeholder']}`, ...register('confirmPassword', {
                                required: props.translations['custom.register.errors.confirm-password'],
                            }) }),
                        errors.confirmPassword?.message && (React.createElement(LoginStyles.Error, null, errors.confirmPassword.message)),
                        React.createElement("br", null),
                        React.createElement(S.PasswordInfo, null, props.translations['custom.signup.password-requirements']),
                        React.createElement(S.PasswordInfo, { green: true }, props.translations['custom.signup.password-requirements.body'])),
                    React.createElement(LoginStyles.Field, { "data-flex": "true" },
                        React.createElement(S.PasswordInfo, { dangerouslySetInnerHTML: {
                                __html: props.translations['custom.signup.implicit-gdpr'],
                            } })),
                    React.createElement(LoginStyles.Field, { "data-flex": "true" },
                        React.createElement(Checkbox, { htmlLabel: true, label: props.translations['custom.signup.gdpr'], ...register('agreedToGDPRConsent', {
                                required: props.translations['custom.register.errors.gdpr'],
                            }), value: watch().agreedToGDPRConsent, onClick: (v) => {
                                setValue('agreedToGDPRConsent', v);
                            } }),
                        errors.agreedToGDPRConsent?.message && (React.createElement(LoginStyles.Error, null, errors.agreedToGDPRConsent.message))),
                    React.createElement(LoginStyles.Field, null,
                        React.createElement(Recaptcha, { shouldLoad: true, siteKey: props.recaptchaSiteKey, value: watch().recaptcha, onChange: (token) => {
                                setValue('recaptcha', token);
                            } }),
                        errors.recaptcha?.message && (React.createElement(LoginStyles.Error, null, errors.recaptcha.message))),
                    React.createElement(LoginStyles.Field, null,
                        React.createElement(Button, { branding: "primaryAlt", title: props.translations['custom.signup.create-account'], disabled: isLoading, onClick: (event) => {
                                event.preventDefault();
                                handleSubmit(submit)(event);
                            } })),
                    React.createElement(LoginStyles.Message, null,
                        props.translations['custom.signup.already-have-account'],
                        ' ',
                        React.createElement(S.Link, { onClick: () => dispatch({
                                type: 'APP/SET_LOGIN_MODAL',
                                payload: {
                                    loginType: LoginRedirectType.Default,
                                },
                            }) }, props.translations['custom.signup.already-have-account.link'])))))));
};
export default withWidget(withRedux(SignupForm), 'SignupForm', { hydrate: HydrateOption.InView });
